import type { TargetAndTransition, Transition } from "motion/react";

/** Spring transition compatible with Motion layout and presence props. */
export interface DynamicIslandSpringTransition {
    "type":      "spring";
    "stiffness": number;
    "damping":   number;
    "mass":      number;
}

/** Lifecycle phase exposed to layout occupancy and debug surfaces. */
export type DynamicIslandAnimationPhase = "idle" | "entering" | "visible" | "exiting";

/** Numeric keyframe pair for shell variant presets. */
export type DynamicIslandMotionKeyframe = readonly [number, number];

/** Shell enter/exit/kind-switch variant definitions. */
export interface DynamicIslandShellVariants {
    "enter": {
        "opacity": DynamicIslandMotionKeyframe;
        "scaleX":  DynamicIslandMotionKeyframe;
        "scaleY":  DynamicIslandMotionKeyframe;
    };
    "exit": {
        "opacity": DynamicIslandMotionKeyframe;
        "scaleX":  DynamicIslandMotionKeyframe;
        "scaleY":  DynamicIslandMotionKeyframe;
    };
    "kindSwitch": {
        "outgoing": {
            "opacity": DynamicIslandMotionKeyframe;
            "x":       DynamicIslandMotionKeyframe;
            "scale":   DynamicIslandMotionKeyframe;
        };
        "incoming": {
            "opacity": DynamicIslandMotionKeyframe;
            "scale":   DynamicIslandMotionKeyframe;
            "originX": number;
        };
    };
    "staggerMs": number;
}

/** Resolved motion configuration for the presence shell. */
/** Resolved shell motion targets for presence animations. */
export interface DynamicIslandShellMotionTargets {
    "initial": TargetAndTransition;
    "animate": TargetAndTransition;
    "exit":    TargetAndTransition;
}

export interface DynamicIslandShellMotionConfig {
    "spring":                DynamicIslandSpringTransition;
    "maxWidthPercent":       number;
    "shell":                 DynamicIslandShellVariants;
    "rtTextPulseDebounceMs": number;
}

/** Instant (reduced-motion / disabled) transition. */
export const DYNAMIC_ISLAND_INSTANT_TRANSITION: Transition = { "duration": 0 };
